(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function applyImageContain() {
    document.querySelectorAll('img.product-media__image').forEach(function(img) {
      img.style.setProperty('object-fit', 'contain', 'important');
      img.style.setProperty('padding', '4%', 'important');
      img.style.setProperty('background-color', '#ffffff', 'important');
      img.style.setProperty('box-sizing', 'border-box', 'important');
    });
  }

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const variantModeActive = document.documentElement.dataset.variantModeActive === 'true';
    if (!variantModeActive) return;

    const cards = document.querySelectorAll('[data-variant-id]');

    cards.forEach((card) => {
      const variantId = card.getAttribute('data-variant-id');
      const variantTitle = card.getAttribute('data-variant-title');
      const variantImage = card.getAttribute('data-variant-image');
      const variantImageSrcset = card.getAttribute('data-variant-image-srcset');
      const variantImageAlt = card.getAttribute('data-variant-image-alt');
      const variantPrice = card.getAttribute('data-variant-price');
      const comparePrice = card.getAttribute('data-variant-compare-price');

      if (!variantId) return;

      const links = card.querySelectorAll('a[href*="/products/"]');
      links.forEach((link) => {
        try {
          const href = link.getAttribute('href');
          if (!href) return;

          const url = new URL(href, window.location.origin);
          url.searchParams.set('variant', variantId);
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (e) {}
      });

      if (variantTitle && variantTitle !== 'Default Title') {
        const titleTargets = card.querySelectorAll(
          '.text-block p, .text-block h1, .text-block h2, .text-block h3, .text-block h4, .text-block h5, .text-block h6, p[role="heading"]'
        );

        titleTargets.forEach((el) => {
          if (!el.dataset.variantEnhanced) {
            const prefix = document.createElement('span');
            prefix.className = 'variant-option-prefix';
            prefix.textContent = variantTitle;
            el.prepend(prefix);
            el.dataset.variantEnhanced = 'true';
          }
        });
      }

      if (variantImage) {
        const images = card.querySelectorAll('img');

        images.forEach((img) => {
          const src = img.getAttribute('src') || '';
          const dataSrc = img.getAttribute('data-src') || '';
          const looksLikeProductImage =
            src.includes('/cdn/shop/') ||
            dataSrc.includes('/cdn/shop/');

          if (looksLikeProductImage) {
            img.src = variantImage;

            if (variantImageSrcset) {
              img.srcset = variantImageSrcset;
            }

            img.alt = variantImageAlt || img.alt || '';

            if (img.hasAttribute('data-src')) {
              img.setAttribute('data-src', variantImage);
            }

            if (img.hasAttribute('data-srcset') && variantImageSrcset) {
              img.setAttribute('data-srcset', variantImageSrcset);
            }
          }
        });

        const sources = card.querySelectorAll('source');
        sources.forEach((source) => {
          if (variantImageSrcset) {
            source.srcset = variantImageSrcset;
          }
        });
      }

      if (variantPrice && !card.dataset.priceEnhanced) {
        const priceEl = card.querySelector('.price-item__group.price, span.price');
        if (priceEl) {
          const textNodes = [...priceEl.childNodes].filter(n => n.nodeType === Node.TEXT_NODE);
          if (textNodes.length > 0) {
            textNodes[textNodes.length - 1].textContent = '\u00a0' + variantPrice;
            card.dataset.priceEnhanced = 'true';
          } else {
            priceEl.insertAdjacentText('beforeend', '\u00a0' + variantPrice);
            card.dataset.priceEnhanced = 'true';
          }
        }
      }

      if (comparePrice && !card.dataset.compareEnhanced) {
        const compareEl = card.querySelector('.price-item__group.compare-at-price, .compare-at-price');
        if (compareEl) {
          const textNodes = [...compareEl.childNodes].filter(n => n.nodeType === Node.TEXT_NODE);
          if (textNodes.length > 0) {
            textNodes[textNodes.length - 1].textContent = '\u00a0' + comparePrice;
            card.dataset.compareEnhanced = 'true';
          }
        }
      }
    });
  });

  setTimeout(applyImageContain, 300);
  setTimeout(applyImageContain, 1000);
  setTimeout(applyImageContain, 3000);

  } catch(e) { console.error(e); }
})();
})();
